<template>
    <div :class="$vuetify.breakpoint.mobile ? '' : ''">
        <v-app-bar
            color="#232323"
            dark
            fixed
            :bottom="$vuetify.breakpoint.mobile"
            flat
            height="60px"
            style="overflow: visible;"
        >
            <v-app-bar-nav-icon class="d-lg-none mr-3" x-large @click.stop="closeDrawer">
                <v-row justify="center">
                    <v-col cols="12" class="px-0 py-0 my-0 mx-0" align="center">
                        <v-icon color="teal">
                            mdi-dots-horizontal
                        </v-icon>
                    </v-col>
                    <v-col cols="12" class="px-0 py-0 my-0 mx-0 caption" align="center">
                        Μενού
                    </v-col>
                </v-row>
            </v-app-bar-nav-icon>
            <div style="display: contents;" class="clickable">
                <img v-if="$vuetify.breakpoint.mobile" width="50px" contain class="main-logo" :src="require('@/assets/main_logo.png')" @click="$router.push({name: 'Home'})">
                <img v-else width="50px" contain :src="require('@/assets/main_logo.png')" @click="$router.push({name: 'Home'})">
                <span v-if="$store.getters.getPlayer && $vuetify.breakpoint.mobile" class="ml-2">
                    <div style="text-transform: capitalize;">
                        Καλώς ήρθες,
                    </div>
                    <div>
                        {{ formattedPlayerName }}
                    </div>
                </span>
                <v-spacer v-if="$vuetify.breakpoint.mobile" />
                <span v-if="$vuetify.breakpoint.mobile" style="text-align: end;" @click="$router.push({name: 'Home'})">
                    <div>
                        <v-icon large class="mr-2" color="teal">mdi-home</v-icon>
                    </div>
                    <div class="">
                        Αρχική
                    </div>
                </span>
            </div>
            <v-tabs
                centered
                class="d-none d-lg-block"
            >
                <v-tabs-slider class="custom-teal" />
                <!-- Render each nav item; if it has subItems show a dropdown menu, otherwise a direct tab -->
                <div v-for="(item, index) in navItems" :key="index" style="display: contents;">
                    <v-menu
                        v-if="item.subItems && item.subItems.length"
                        :key="`menu-${index}`"
                        transition="slide-y-transition"
                        bottom
                        offset-y
                        rounded="0"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-tab :value="`tab-${index}`" style="font-size: 25px;" v-bind="attrs" v-on="on">
                                <span>{{ item.name }}</span>
                            </v-tab>
                        </template>
                        <v-list color="#232323" style="background: #232323;">
                            <v-list-item
                                v-for="(subItem, i) in item.subItems"
                                :key="`sub-${index}-${i}`"
                                :to="`/${subItem.link}${subItem.id ? '/' + subItem.id : ''}`"
                            >
                                <span style="font-size: 20px;" class="white--text">{{ subItem.name }}</span>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-tab
                        v-else
                        :key="`tab-${index}`"
                        :value="`tab-${index}`"
                        :to="item.link ? `/${item.link}` : undefined"
                        style="font-size: 25px;"
                    >
                        <span>{{ item.name }}</span>
                    </v-tab>
                </div>
            </v-tabs>
            <div v-if="($store.getters.getPlayer || $store.getters.getTeam) && !$vuetify.breakpoint.mobile" style="display: contents;">
                <span>
                    <v-btn
                        icon
                        large
                        color="teal"
                        @click="$router.push({name: 'Team', params: { id: $store.getters.getTeam.id } })"
                    >
                        <v-avatar style="border-radius: 10px;" color="white" height="auto" width="50">
                            <v-img v-if="$store.getters.getTeam.logo" contain width="50px" :src="`${assetsUrl}/${$store.getters.getTeam.logo}`" />
                            <v-icon v-else class="teal--text" large> mdi-account-group </v-icon>
                        </v-avatar>
                    </v-btn>
                </span>
                <v-divider
                    vertical
                    class="custom-divider"
                />
                <span>
                    <v-btn
                        v-if="!$vuetify.breakpoint.mobile"
                        icon
                        @click="$store.getters.getPlayer ? $router.push({name: 'Player', params: { id: $store.getters.getPlayer.id } }) : $router.push({name: 'Profile'})"
                    >
                        <v-avatar v-if="$store.getters.getPlayer" style="border-radius: 10px;" height="auto" width="50">
                            <v-img v-if="$store.getters.getPlayer.image" contain :src="`${assetsUrl}/${$store.getters.getPlayer.image}`" />
                            <v-icon v-else class="teal--text" large> mdi-account </v-icon>
                        </v-avatar>
                        <v-icon v-else large class="teal--text">mdi-account</v-icon>
                    </v-btn>
                </span>
                <v-btn
                    fab
                    x-small
                    class="custom-teal"
                    to="/Profile"
                    style="position: absolute; right: 0; top: 40px;"
                >
                    <v-icon class="white--text">mdi-cog</v-icon>
                </v-btn>
            </div>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            temporary
            disable-resize-watcher
            width="80vw"
            style="z-index: 101; background: #232323;"
            dark
        >
            <v-list
                nav
                dense
                class="text-center"
            >
                <v-row>
                    <v-col v-if="secondaryOptions" cols="12" align="start">
                        <v-icon large class="custom-teal-text" @click="secondaryOptions = false; getNavItems()">
                            mdi-arrow-left
                        </v-icon>
                    </v-col>
                    <!-- <v-col v-else cols="12" align="center">
                        <v-img
                            height="53px"
                            width="180px"
                            class="my-2"
                            :src="require('@/assets/google_play.png')"
                            @touchstart="openSocial('google_play')"
                        />
                        <v-img
                            height="53px"
                            width="160px"
                            :src="require('@/assets/app_store.svg')"
                            @touchstart="openSocial('app_store')"
                        />
                    </v-col> -->
                </v-row>
                <v-list-item-group
                    v-for="(item, index) in showMenuItems"
                    :key="index"
                    active-class="text--accent-4"
                >
                    <v-list-item class="border-bottom">
                        <v-list-item-title class="white--text text-h6" @click="item.secondaryOptions ? setMenu(item) : menuActionClick(item)">
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
                <v-list-item class="border-bottom justify-center">
                    <div class="custom-teal-text">Official EKA BASKET Appearance</div>
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <img
                        height="100px"
                        width="auto"
                        :src="require('@/assets/gsa.jpg')"
                        style="cursor: pointer;"
                        class="mb-5"
                        @click="openSocial('gsa')"
                    >
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <div class="custom-teal-text">Official EKA BASKET Ball</div>
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <img
                        height="100px"
                        width="auto"
                        :src="require('@/assets/molten.png')"
                        style="cursor: pointer;"
                        class="mb-5"
                        @click="openSocial('molten')"
                    >
                </v-list-item>
                <!-- <v-list-item class="border-bottom justify-center">
                    <div class="custom-teal-text">Επίσημο Κέντρο Φυσικοθεραπευτικής Αποκατάστασης EKA BASKET</div>
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <img
                        height="100px"
                        width="auto"
                        :src="require('@/assets/TheraMotion_logo.jpg')"
                        style="cursor: pointer;"
                        class="mb-5"
                        @click="openSocial('TheraMotion')"
                    >
                </v-list-item> -->
                <v-list-item class="border-bottom justify-center">
                    <div class="custom-teal-text">Powered by</div>
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <img
                        height="100px"
                        width="auto"
                        :src="require('@/assets/sportsiq.jpg')"
                        style="cursor: pointer;"
                        class="mb-5"
                        @click="openSocial('sportsiq')"
                    >
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <div class="custom-teal-text">Official Sponsor</div>
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <img
                        height="100px"
                        width="auto"
                        :src="require('@/assets/e-academy.png')"
                        style="cursor: pointer;"
                        class="mb-5"
                        @click="openSocial('e-academy')"
                    >
                </v-list-item>
                <v-list-item class="border-bottom justify-center">
                    <v-icon large class="custom-teal-text" @click="openSocial('facebook')"> mdi-facebook</v-icon>
                    <v-icon large class="custom-teal-text mx-5" @click="openSocial('instagram')"> mdi-instagram</v-icon>
                    <v-icon large class="custom-teal-text mr-5" @click="openSocial('youtube')"> mdi-youtube </v-icon>
                    <v-icon large class="custom-teal-text mr-5" @click="openSocial('twitter')"> mdi-twitter </v-icon>
                    <v-icon large class="custom-teal-text mr-5" @click="openSocial('linkedin')"> mdi-linkedin </v-icon>
                    <!-- <img
                        width="30px"
                        contain
                        style="display: inline-flex;"
                        :src="require('@/assets/tiktok-gradient.svg')"
                        @click="openSocial('tiktok')"
                    > -->
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        name: 'NavBar',
        data() {
            return {
                drawer: false,
                secondaryOptions: false,
                assetsUrl: 'https://storage.googleapis.com',
                currentMenuName: null,
                navItems: [],
                showMenuItems: []
            }
        },
        computed: {
            formattedPlayerName() {
                const player = this.$store && this.$store.getters ? this.$store.getters.getPlayer : null
                if (!player || !player.name) return ''
                const raw = player.name
                const formatted = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase()
                const max = 12
                return formatted.length > max ? formatted.slice(0, max) + '...' : formatted
            },
            leagueGroups() {
                return this.$store.getters.getLeagueGroups
            },
            leagues() {
                return this.$store.getters.getLeagues
            },
            cupLeagues() {
                return this.$store.getters.getCupLeagues
            }
        },
        watch: {
            leagueGroups() {
                this.buildNavItems()
            },
            leagues() {
                this.buildNavItems()
            },
            cupLeagues() {
                this.buildNavItems()
            }
        },
        created() {
            this.navItems = this.createBaseNavItems()
            this.showMenuItems = this.navItems
            this.initializeMenu()
        },
        methods: {
            createBaseNavItems() {
                return [
                    {
                        name: 'Home',
                        link: 'Home'
                    },
                    {
                        name: 'Teams',
                        link: 'Teams'
                    },
                    {
                        name: 'Cup',
                        link: '',
                        secondaryOptions: true,
                        subItems: []
                    },
                    {
                        name: 'Courts',
                        link: 'Courts'
                    },
                    {
                        name: 'Profile',
                        link: 'Profile'
                    },
                    {
                        name: 'The League',
                        link: '',
                        secondaryOptions: true,
                        subItems: [
                            {
                                name: 'Εγγραφή',
                                link: 'Register'
                            },
                            {
                                name: 'Επικοινωνία',
                                link: 'ContactUs'
                            }
                        ]
                    }
                ]
            },
            async initializeMenu() {
                await Promise.all([
                    this.$store.dispatch('ensureLeagueGroups'),
                    this.$store.dispatch('ensureLeagues'),
                    this.$store.dispatch('ensureCupLeagues')
                ])
                this.buildNavItems()
            },
            buildNavItems() {
                const navItems = this.createBaseNavItems()

                this.leagueGroups.forEach(leagueGroup => {
                    navItems.splice(navItems.length - 3, 0, {
                        name: leagueGroup.title,
                        link: '',
                        subItems: [],
                        secondaryOptions: true
                    })
                })

                this.cupLeagues.forEach(cupLeague => {
                    navItems[2].subItems.push({
                        name: cupLeague.title,
                        link: 'CupLeague',
                        id: cupLeague.id
                    })
                })

                this.leagues.forEach(league => {
                    const leagueGroupItem = navItems.find(item => item.name === league.leagueGroup.title)
                    if (leagueGroupItem) {
                        leagueGroupItem.subItems.push({
                            name: league.title,
                            link: 'League',
                            id: league.id
                        })
                    }
                })

                this.navItems = navItems
                this.getNavItems(this.currentMenuName ? { name: this.currentMenuName } : null)
            },
            closeDrawer() {
                if (this.secondaryOptions) {
                    this.secondaryOptions = false
                    this.currentMenuName = null
                    this.getNavItems()
                    if (!this.drawer) {
                        this.drawer = !this.drawer
                    }
                } else {
                    this.drawer = !this.drawer
                }
            },
            setMenu(item) {
                this.secondaryOptions = true
                this.currentMenuName = item.name
                this.getNavItems(item)
            },
            getNavItems(item) {
                if (item && this.secondaryOptions) {
                    const orgItem = this.navItems.find(i => i.name === item.name)
                    this.showMenuItems = orgItem && orgItem.subItems ? orgItem.subItems : []
                } else {
                    this.showMenuItems = this.navItems
                }
            },
            menuActionClick(item) {
                if (item.link === this.$route.name && (!item.id || item.id === this.$route.params.id)) {
                    this.drawer = false
                } else {
                    if (item.link === 'League') {
                        this.$router.push({ name: item.link, params: { id: item.id } })
                    } else if (item.link === 'CupLeague') {
                        this.$router.push({ name: item.link, params: { id: item.id } })
                    } else {
                        this.$router.push({ name: item.link })
                    }
                }
            },
            openSocial(social) {
                if (social === 'facebook') {
                    window.open('https://www.facebook.com/eka.league.gr', '_blank')
                } else if (social === 'instagram') {
                    window.open('https://www.instagram.com/eka_league.gr/', '_blank')
                } else if (social === 'youtube') {
                    window.open('https://www.youtube.com/channel/UC5hvrVJnTvrSrcf970QpqNg', '_blank')
                } else if (social === 'tiktok') {
                    window.open('', '_blank')
                } else if (social === 'twitter') {
                    window.open('https://x.com/Comm_league', '_blank')
                } else if (social === 'linkedin') {
                    window.open('https://www.linkedin.com/company/eka-league/', '_blank')
                } else if (social === 'gsa') {
                    window.open('https://www.gsasport.com/gr/', '_blank')
                } else if (social === 'google_play') {
                    window.open('https://play.google.com/store/apps/details?id=com.vue.big.app', '_blank')
                } else if (social === 'app_store') {
                    window.open('https://apps.apple.com/us/app/b-i-g/id6748522198', '_blank')
                } else if (social === 'e-academy') {
                    window.open('https://eacademy.gr/', '_blank')
                }
            }
        }
    }
</script>

<style>
.v-list-item--active {
    color: transparent !important;
}
</style>

<style scoped>

.wave {
    display: block;
    position: relative;
    height: 50px;
    width: 100%;
    background: #f2d16b;
    transform: scale(1, 1);
}

.wave::before {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 300px;
    background-color: #f2d16b;
    right: -25%;
    top: 20px;
}

.wave::after {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 310px;
    background-color: #f2d16b;
    left: -25%;
    top: -240px;
    clip-path: ellipse(100% 15% at -15% 100%);
}

.divider-wrapper {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
}

.custom-divider {
    border-color: teal;
    border-width: 1px;
    height: 20px;
    margin: 0 10px 0 10px;
    display: inline-flex;
    min-height: 100%;
    max-height: 100%;
    vertical-align: text-bottom;
}

.v-application .caption {
    font-size: 0.75rem !important;
    letter-spacing: 0.0333333333em !important;
    line-height: 1.25rem;
    font-family: Arial, sans-serif !important;
    text-transform: capitalize;
}

.text-h6 {
    font-size: 1.25rem !important;
    letter-spacing: 0.0125em !important;
    line-height: 2rem;
    font-family: Arial, sans-serif !important;
}

.v-overlay__scrim {
    opacity: 0 !important;
}

.show-ball {
    color: teal !important;
}

.v-tabs {
    width: 50% !important;
    margin: 0 auto !important;
}

/* Center tabs only on large screens so the Vuetify responsive utility (d-none d-lg-block) can hide them on mobile */
@media (min-width: 992px) {
    .v-tabs {
        display: flex !important;
        justify-content: center !important;
    }
}

.v-tab {
    font-weight: bolder;
    font-size: 15px;
    color: white !important;
    text-transform: none !important;
}

.v-tab::before {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    background-color: transparent;
}

.main-logo {
    align-self: self-start;
}

.app-bar-carousel {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%; /* place it visually just above the app-bar content */
    width: 100%;
    z-index: 102;
}

.menu-item:hover {
    color: #f7941e;
    cursor: pointer !important;
}

.v-navigation-drawer--absolute {
    width: 100vw !important;
    height: auto;
}

.v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
    line-height: 3.7;
    align-self: center;
    font-size: 1.5rem;
    color: teal;
    font-weight: bolder;
    opacity: 1 !important;
}
</style>
